import React from 'react';
import { Typography } from '@mui/material';
import InformationPage from '../../components/InformationPage';

export const ContactUs: React.FC = () => {
  return (
    <InformationPage>
      <Typography variant="h2" paragraph color="secondary">
        CONTACT US
      </Typography>
      <Typography variant="h5" gutterBottom color="textPrimary" className="max-w-[550px]">
        Feel free to give us feedback on our platform by sending an email to
      </Typography>
      <Typography
        variant="h3"
        gutterBottom
        color="textPrimary"
        component="a"
        href="mailto:contact@bluecargo.io"
      >
        contact@bluecargo.io
      </Typography>
    </InformationPage>
  );
};
